export default __webpack_public_path__ + "static/media/retake.47f5827b.png";